import React, { Suspense } from "react";
import Notification from "./notifications/Notification";
import { dispatchAlert } from "../../actions/UserActions";
import { useDispatch, useSelector } from "react-redux";
const Alert = React.lazy(() => import('./alert/Alert'));


function NotificationContainer() {
    const alert = useSelector(state => state.notifications.alert)
    const dispatch = useDispatch();

    return <>
        <Notification />
        {alert?.isVisible && <Suspense fallback={<></>}><Alert
            placement={alert?.placement}
            size={alert?.size}
            className={alert?.className}
            icon={alert?.icon}
            title={alert?.title}
            isVisible={alert?.isVisible}
            onClose={() => dispatch(dispatchAlert({
                isVisible: false
            }))}
        /></Suspense>}
    </>

}

export default NotificationContainer;